import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import classes from './Page.module.css';
import ChatWidget from "../ChatWidget/ChatWidget";

const Page = (props) => {
  return (
    <div className={classes.page}>
        <Header />
        <ChatWidget />
            {props.children}
        <Footer />
    </div>
  )
}

export default Page